import request from '../utils/request'

export function getDomain(params) { // 获取配置域名
    return request({
        url: '/tougaos/tougaos/domain',
        method: 'GET',
        params
    })
}

export function tougaoInfo(params) { // 投稿活动详情
    return request({
        url: '/tougaos/tougaos/info',
        method: 'GET',
        params
    })
}

export function tougaoSetting(params) { // 获取投稿配置信息
    return request({
        url: '/tougaos/setting/info',
        method: 'GET',
        params
    })
}

export function tougaoBanners(params) { // /api/tougaos/lunboo
    return request({
        url: '/tougaos/banner/index',
        method: 'GET',
        params
    })
}

export function tougaosCategorys(params) { // 投稿活动的分类
    return request({
        url: '/tougaos/category/index',
        method: 'GET',
        params
    })
}

export function touGaoList(query) { // 投稿列表
    return request({
        url: '/tougaos/tougaos/mylist',
        method: 'get',
        params: query
    })
}

export function saveMember(data) { // 投稿人员新增
    return request({
        url: '/tougaos/members/add',
        method: 'POST',
        data
    })
}

export function editMember(data) { // 投稿人员编辑
    return request({
        url: '/tougaos/members/edit',
        method: 'POST',
        data
    })
}

export function memberInfo(params) { // 投稿人员详情
    return request({
        url: '/tougaos/members/info',
        method: 'GET',
        params
    })
}

export function addZuopin(data) { // 投稿作品新增
    return request({
        url: '/tougaos/zuopins/add',
        method: 'POST',
        data
    })
}

export function editZuopin(data) { // 投稿作品编辑
    return request({
        url: '/tougaos/zuopins/edit',
        method: 'POST',
        data
    })
}

export function zuopinInfo(params) { // 投稿作品详情
    return request({
        url: '/tougaos/zuopins/info',
        method: 'GET',
        params
    })
}

export function deleteZuopin(params) { // 投稿作品删除
    return request({
        url: '/tougaos/zuopins/delete',
        method: 'GET',
        params
    })
}

export function zuopinList(params) { // 我的作品列表
    return request({
        url: '/tougaos/zuopins/index',
        method: 'GET',
        params
    })
}

export function confirmZuopin(data) { // 确认提交投稿作品
    return request({
        url: '/tougaos/zuopins/confirm',
        method: 'POST',
        data
    })
}
